import { toFixedNoRound } from '@okletsplay/core';
import { calculateTokensWithDecimals } from 'shared/utils';
import { RampQuota } from '../interfaces/ramp-quota';
import { getDecimalsForToken } from './get-decimals-for-token';

export const calculateQuotaMinAmount = ({
  tokenName,
  fiatCurrency,
  quota,
}: {
  tokenName: string;
  fiatCurrency: string;
  quota: RampQuota;
}): string => {
  const { minPurchaseCryptoAmount, minPurchaseAmount, price } = quota?.asset ?? {};

  const decimals = getDecimalsForToken(tokenName);

  if (!decimals) {
    return '0';
  }

  if (
    minPurchaseCryptoAmount &&
    minPurchaseCryptoAmount !== '-1' &&
    minPurchaseCryptoAmount !== '0'
  ) {
    return calculateTokensWithDecimals(minPurchaseCryptoAmount, decimals);
  }

  if (!minPurchaseAmount) {
    return '0';
  }

  const exchangeRate = price && price[fiatCurrency];

  if (!exchangeRate) {
    return '0';
  }

  const cryptoAmount = toFixedNoRound(exchangeRate * minPurchaseAmount, 4);
  return calculateTokensWithDecimals(cryptoAmount, decimals);
};
